import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; 
import Modal from "./Modal";
import AlertModal from "./AlertModal";
import btnLogin from "../assets/images/btn_login.svg";
import btnRegister from "../assets/images/btn_register.svg";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";

const Sidebar  = ({ isOpen, onClose, isMobile }) => {

  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = "hidden";  // 모바일에서 사이드바가 열리면 스크롤 막기
    } else {
      document.body.style.overflow = "auto";  // 사이드바가 닫히면 스크롤 가능
    }

    return () => document.body.style.overflow = "auto";  // 컴포넌트 언마운트 시
  }, [isOpen, isMobile]);

  const location = useLocation();
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isRegisterOpen, setRegisterOpen] = useState(false);
  const [nickname, setNickname] = useState("");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nicknameAvailable, setNicknameAvailable] = useState(false);
  const [userIdAvailable, setUserIdAvailable] = useState(false);
  const [userType, setUserType] = useState(""); 
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const navigate = useNavigate();

  // 현재 페이지 경로 확인
  const isActive = (path) => (location.pathname === path ? "active" : "");

  // 컴포넌트가 마운트될 때 로그인 상태 확인
  useEffect(() => {
    const storedUserType = localStorage.getItem("userType");
    const storedUserName = localStorage.getItem("userName");
    const storedIsLoggedIn = localStorage.getItem("isLoggedIn");

    if (storedIsLoggedIn === "true") {
      setUserName(storedUserName);
      setIsLoggedIn(true);
      setUserType(storedUserType);
    }

  }, []);

  
useEffect(() => {
  if (isRegisterOpen) {
    setNickname("");
    setUserId("");
    setPassword("");
    setConfirmPassword("");
  }
}, [isRegisterOpen]);

useEffect(() => {
  if (isLoginOpen) {
    setUserId("");
    setPassword("");
  }
}, [isLoginOpen]);

    // 닉네임 중복 확인
    const checkDuplicateNickname = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}//api/admin/check-nickname?nickname=${nickname}`,{
           headers: {
      
           'X-Frontend-Request': 'true',
        },
        });
        if (!response.ok) {
          throw new Error("서버 오류");
        }
        const isUnique = await response.json();
      
        if (!isUnique) {
           showAlert("사용 가능한 닉네임입니다.");
          setNicknameAvailable(true);
        } else {
           showAlert("이미 사용 중인 닉네임입니다.");
          setNicknameAvailable(false);
        }
      } catch (error) {
        console.error("닉네임 중복 확인 오류:", error);
         showAlert("중복 확인 중 오류가 발생했습니다.");
      }
    };

    // 아이디 중복 확인
    const checkDuplicateUserId = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/check-username?username=${userId}`,{
             headers: {
      
           'X-Frontend-Request': 'true',
        },
        });
        if (!response.ok) {
          throw new Error("서버 오류");
        }
        const isUnique = await response.json();
      
        if (!isUnique) {
          
           showAlert("사용 가능한 아이디입니다.");
          setUserIdAvailable(true);
        } else {
           showAlert("이미 사용 중인 아이디입니다.");
          setUserIdAvailable(false);
        }
      } catch (error) {
        console.error("아이디 중복 확인 오류:", error);
         showAlert("중복 확인 중 오류가 발생했습니다.");
      }
    };

    const showAlert = (message) => {
      setAlertMessage(message);
      setIsAlertOpen(true);
    };
    
  // 로그인 API 호출
  const handleLogin = async (e) => {
    if (e?.preventDefault) e.preventDefault(); // e가 존재할 때만 실행

    if (!userId || !password) {
       showAlert("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    const loginData = {
      username: userId,
      password: password,
    };
     
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
       
        method: "POST",
        headers: {
          "Content-Type": "application/json",  // JSON 형식으로 데이터를 전송
           'X-Frontend-Request': 'true',
        },
        body: JSON.stringify(loginData),  // JSON 데이터를 body로 전송
      });
    
      if (response.ok) {
        const user = await response.json();
        setUserName(user.username); // 로그인 성공 시 사용자 이름 업데이트
        setUserType(user.adminType);
        setIsLoggedIn(true); // 로그인 상태로 변경
        setLoginOpen(false); // 로그인 모달 닫기

        
        // 로그인 상태를 localStorage에 저장
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userName", user.username);
        localStorage.setItem("userType", user.adminType);

      } else {
        // 로그인 실패 (401 Unauthorized)
        const errorMessage = await response.text();  // 실패 메시지 처리
         showAlert(errorMessage);  // 오류 메시지 표시
      }
    
    } catch (error) {
      console.error("로그인 오류:", error);
       showAlert("로그인 중 오류가 발생했습니다.");
    }
  };

  // 로그아웃
  const handleLogout =  async (e) => {
    e.preventDefault();
    setIsLoggedIn(false);
    setUserName("");
    setUserType(""); 

    // localStorage에서 로그인 상태 제거
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userName");
    localStorage.removeItem("userType");
    navigate("/login");
  };

  // 회원가입 API 호출
  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (!userId.trim() || !nickname.trim() || !password.trim()) {
       showAlert("아이디, 닉네임, 비밀번호를 모두 입력해주세요.");
      return;
    }
  
    if (password !== confirmPassword) {
       showAlert("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!nicknameAvailable || !userIdAvailable) {
       showAlert("닉네임 또는 아이디 중복 확인을 완료해 주세요.");
      return;
    }
    const registerData = {
      username: userId,
      nickname: nickname,
      password: password,
      adminType: "대리점",
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/register`, {
      
        method: "POST",
        headers: {
          "Content-Type": "application/json",  // JSON 형식으로 데이터를 전송
           'X-Frontend-Request': 'true',
        },
        body: JSON.stringify(registerData),
      });
  
      if (!response.ok) {
        throw new Error("회원가입 실패");
      }
  
      const data = await response.json();
     
      // ✅ 회원가입 성공 후 자동 로그인 처리
      handleLogin(userId, password);
  
      setRegisterOpen(false);
    } catch (error) {
      console.error("회원가입 오류:", error);
       showAlert("회원가입 중 오류가 발생했습니다.");
    }
  };

    
    return (

   

     <div className={`sidebar ${isOpen ? "open" : ""} ${isMobile ? "mobile" : ""}`}>
       <div className="profile">
          <div className="profile-thumb">
            <i className="fa-regular fa-user"></i>
          </div>
          {isLoggedIn === null ? null : isLoggedIn ? (
        <>
          <p className="profile-name">
            {userName}님 안녕하세요!
            {userType && (
              <span
                className={`badge ${
                  userType === "어드민"
                  ? "badge-admin"
                  : userType === "본사"
                    ? "badge-main"
                    : userType === "부본사"
                    ? "badge-sub"
                    : "badge-agent"
                }`}
              >
                {userType}
              </span>
            )}
          </p>
          <div className="profile-btn">
            <button className="btn-logout btn-primary" onClick={handleLogout}>
              로그아웃
            </button>
          </div>
        </>
      ) : (
        <>
      
        </>
      )}
        </div>
        <nav className="menu">
          <ul>
            <li>
              <Link to="/" className={isActive("/")} onClick={onClose}>
                <i className="fa-regular fa-chess-knight"></i> 게임 관리
              </Link>
            </li>
            <li>
              <Link to="/coin" className={isActive("/coin")} onClick={onClose}>
                <i className="fa-regular fa-coins"></i> 알 화폐 관리
              </Link>
            </li>
            <li>
              <Link to="/users" className={isActive("/users")} onClick={onClose}>
                <i className="fa-regular fa-user"></i> 유저 관리
              </Link>
            </li>
            <li>
                <Link to="/BetManagement" className={isActive("/BetManagement")} onClick={onClose}>
                  <i className="fa-solid fa-dice"></i> 배팅 관리
                </Link>
            </li>
              {/* ✅ 하부업체가 아닌 사용자에게만 보이는 메뉴 */}
              { userType !== "대리점" && isLoggedIn && (
                  <>
                    <li>
                      <Link to="/agency" className={isActive("/agency")} onClick={onClose}>
                        <i className="fa-solid fa-store"></i> 대리점 관리
                      </Link>
                    </li>
                     { userType !== "부본사" && isLoggedIn && (
                      <>
                    <li>
                      <Link to="/api" className={isActive("/api")} onClick={onClose}>
                        <i className="fa-solid fa-key"></i> API 키 관리
                      </Link>
                    </li>
                       <li>
                       <Link to="/statistics" className={isActive("/statistics")} onClick={onClose}>
                         <i className="fa-solid fa-chart-bar"></i> 통계 관리
                       </Link>
                     </li></>
                   ) }
                  
                   
                  </>
                )}
          </ul>
        </nav>

        {/* 로그인 모달 */}
        <Modal id="modalLogin" isOpen={isLoginOpen} closeModal={() => setLoginOpen(false)}>
          <form className="form-area">
            <div className="form-item">
              <label>ID</label>
              <input
                type="text"
                name="username"
                value={userId}
                onChange={(e) => setUserId(e.target.value)} // userId 상태 설정
                autoComplete="username"
              />
            </div>
            <div className="form-item">
              <label>PW</label>
              <input
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // password 상태 설정
                autoComplete="current-password"
              />
            </div>
            <button
              className="btn-primary"
              onClick={handleLogin} // 로그인 로직 추가
              style={{ backgroundColor: "#3498db" }}
            >
              로그인
            </button>
          </form>
        </Modal>
       
        {/* 회원가입 모달 */}
        <Modal id="modalRegister" isOpen={isRegisterOpen} closeModal={() => setRegisterOpen(false)}>
          <form className="form-area">
            <div className="form-item">
              <label>닉네임</label>
              <div className="input-group">
                <input
                  type="text"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)} // nickname 상태 설정
                />
                 <button type="button" className="btn-check" onClick={checkDuplicateNickname}>중복 확인</button>
              </div>
            </div>
          
            <div className="form-item">
              <label>아이디</label>
              <div className="input-group">
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)} // userId 상태 설정
                />
                  <button type="button" className="btn-check" onClick={checkDuplicateUserId}>중복 확인</button>
              </div>
            </div>

            <div className="form-item">
              <label>비밀번호</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // password 상태 설정
              />
            </div>

            <div className="form-item">
              <label>비밀번호 확인</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} // confirmPassword 상태 설정
              />
            </div>

            <button
              className="btn-primary"
              onClick={handleRegister} // 회원가입 로직 추가
              style={{ backgroundColor: "#2ecc71" }}
            >
              회원가입
            </button>
          </form>
        </Modal>

        {isAlertOpen && <AlertModal message={alertMessage} onClose={() => setIsAlertOpen(false)} />}
       
      </div>
    );
  };

  export default Sidebar;
